import { configureStore } from "@reduxjs/toolkit";
import { hospitalReducer } from "./reducers/hospitalReducer";
import { doctorReducer } from "./reducers/doctorReducer";
import { blogReducer } from "./reducers/blogReducer";
import { specialistReducer } from "./reducers/specialistReducer";

export const store = configureStore({
  reducer: {
    hospital: hospitalReducer,
    doctor: doctorReducer,
    blog: blogReducer,
    specialist: specialistReducer,
  },
});
